import Api from "./baseApi";

const controllerPath = "/entities";

const EntityApi = {
  post(data) {
    return Api.post(`${controllerPath}`, data);
  },
  /**
   * Grava o JSON da entidade e aplica o DDL. Devolve a resposta do axios: o corpo (response.data)
   * pode trazer { warnings: [...] } — falhas no banco que não impedem o salvamento, como índice
   * não aplicado — ou vir vazio (ver extractUploadWarnings em entityUtils).
   */
  upload(entityName, file, comment = '') {
    const formData = new FormData();
    formData.append("file", file);
    if (comment) {
      formData.append("comment", comment);
    }

    return Api.post(`${controllerPath}/${entityName}/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  get(options) {
    return Api.getList(`${controllerPath}`, options);
  },
  getAll(options) {
    return Api.get(`${controllerPath}`, options);
  },
  getByName(entityName) {
    return Api.get(`${controllerPath}/${entityName}`);
  }
  ,
  /**
   * Índices da tabela no banco:
   * { table, exists, indexes: [{ name, columns, unique, comment, kind }] }
   * kind: PRIMARY | RULES_UNIQUE | FK | MANAGED (criado pela entidade) | EXTERNAL
   */
  getIndexes(entityName) {
    return Api.get(`${controllerPath}/${entityName}/indexes`);
  },
  normalize(entityName, token) {
    const options = {};
    if (token) {
      options.headers = { Authorization: token };
    }
    return Api.post(`${controllerPath}/${entityName}/normalize`, null, options);
  },
  delete(entityName, dropFromDb = false) {
    return Api.delete(`${controllerPath}/${entityName}?dropFromDb=${dropFromDb}`);
  }
};

export default EntityApi;
